// extracted by mini-css-extract-plugin
export var keychangeHolder = "Keychange-module--keychangeHolder--P-ktK";